<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <h3 class="mt-3">
        {{
          $getVisibleNames(
            "mesh.modalityegressprofile",
            false,
            "Modalidad del Perfil de Egreso"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.modalityegressprofile'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_modalityegressprofile'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.modalityegressprofile',
                  false,
                  'Modalidad del Perfil de Egreso'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-modality-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Modalidad del Perfil de Egreso -->
        </div>
      </div>
      <GenericBTable
        v-if="searchModality.length > 0"
        :items="modalities_egress_profiles"
        :pagination="modalities_egress_profiles.length"
        :fields="modalitiesFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(actions)="row">
          <template v-if="allows_crud">
            <b-button
              variant="none"
              class="m-0 p-0 mr-2"
              v-b-tooltip.v-secondary.noninteractive="
                $t(
                  'curricularDefinitions.modalityEgressProfile.editRequirementsTooltip'
                )
              "
              @click="$bvModal.show(`limit-study-plan-modal-${row.item.id}`)"
            >
              <b-icon icon="journal-text" scale="1"></b-icon>
            </b-button>
            <ButtonSmall
              :tooltip_text="
                $t('reusable.common.editTooltip', {
                  entity: $getVisibleNames(
                    'mesh.modalityegressprofile',
                    false,
                    'Modalidad del Perfil de Egreso'
                  ),
                })
              "
              :click_button="
                () => $bvModal.show(`edit-modality-modal-${row.item.id}`)
              "
              :class="`mx-1`"
              :icon="'square'"
            ></ButtonSmall>
            <ButtonSmall
              :click_button="() => askForDeleteModality(row.item.id)"
              :tooltip_text="
                $t('reusable.common.deleteTooltip', {
                  entity: $getVisibleNames(
                    'mesh.modalityegressprofile',
                    false,
                    'Modalidad del Perfil de Egreso'
                  ),
                })
              "
              :icon="'trash'"
            ></ButtonSmall>
          </template>
          <template v-else>
            <b-button
              variant="none"
              class="m-0 p-0 mr-2"
              v-b-tooltip.v-secondary.noninteractive="
                $t(
                  'curricularDefinitions.modalityEgressProfile.viewRequirementsTooltip'
                )
              "
              @click="$bvModal.show(`limit-study-plan-modal-${row.item.id}`)"
            >
              <b-icon icon="journal-text" scale="1"></b-icon>
            </b-button>
          </template>
          <b-modal
            :id="`limit-study-plan-modal-${row.item.id}`"
            :title="
              !allows_crud
                ? $t(
                    'curricularDefinitions.modalityEgressProfile.viewRequirementsModalTitle'
                  )
                : $t(
                    'curricularDefinitions.modalityEgressProfile.editRequirementsModalTitle'
                  )
            "
            size="xl"
            hide-footer
          >
            <LimitStudyPlan
              :modality_egress_profile_id="row.item.id"
              :allows_crud="
                allows_crud &&
                ([
                  'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                  'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                  'DIRECTIVOS FACULTAD O ESCUELA',
                ].some((group) => user.group_names.includes(group)) ||
                  user.is_superuser)
              "
            ></LimitStudyPlan>
          </b-modal>
          <b-modal
            :id="`edit-modality-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.modalityegressprofile',
                  false,
                  'Modalidad del Perfil de Egreso'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <ModalityEgressProfileForm
              :modalityEgressProfile="row.item"
              @updated="slotUpdatedModality"
              :institution_id="row.item.school"
              :show_title="false"
            ></ModalityEgressProfileForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <strong
          >{{ $t("reusable.common.noDataFound") }}
          {{
            $getVisibleNames(
              "mesh.modalityegressprofile",
              false,
              "Modalidad del Perfil de Egreso"
            )
          }}.</strong
        >
      </div>
    </div>
    <b-modal
      :id="`new-modality-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.modalityegressprofile',
            false,
            'Modalidad del Perfil de Egreso'
          ),
        })
      "
      size="md"
    >
      <ModalityEgressProfileForm
        v-if="user"
        @created="slotCreatedModality"
        :institution_id="user.school"
      ></ModalityEgressProfileForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "ModalityEgressProfileView",
  components: {
    ModalityEgressProfileForm: () =>
      import(
        "@/components/mesh/CurricularResources/ModalityEgressProfile/ModalityEgressProfileForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    LimitStudyPlan: () =>
      import("@/components/mesh/EgressProfile/LimitStudyPlan"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },

    display_id: {},
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      modalities_egress_profiles: names.MODALITIES_EGRESS_PROFILE,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.modalityegressprofile",
            false,
            "Modalidad del Perfil de Egreso"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "mesh.add_modalityegressprofile"
      );
      if (has_permission) return has_permission;
      else return false;
    },
    searchModality: function () {
      return this.modalities_egress_profiles
        .filter((item) => {
          return (
            item.name.toLowerCase().includes(this.input_search.toLowerCase()) ||
            item.description
              .toLowerCase()
              .includes(this.input_search.toLowerCase())
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
    modalitiesFields() {
      if (!this.allows_crud)
        return this.modalities_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.modalities_fields;
    },
    modalities_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.modalityegressprofile",
              true,
              "Modalidades del Perfil de Egreso"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    askForDeleteModality(modality_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.modalityegressprofile",
            false,
            "Modalidad del Perfil de Egreso"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_MODALITY_EGRESS_PROFILE, modality_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.modalityegressprofile",
                    false,
                    "Modalidad del Perfil de Egreso"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedModality(response) {
      this.$bvModal.hide("new-modality-modal");
      this.$bvModal.show(`limit-study-plan-modal-${response.id}`);
    },
    slotUpdatedModality(modality) {
      this.$bvModal.hide(`edit-modality-modal-${modality.id}`);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_MODALITIES_EGRESS_PROFILE);
  },
  created() {},
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-modality {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>